import { Injectable } from '@angular/core';
import { TokenResponseModel } from '../_models/index';
import { UserForgetPasswordRequestModel } from '../_models/Request/UserForgetPasswordRequestModel';
import { ApiSendService } from '@global-services/ApiSend.service';
import {ApiUrlEnum } from '@global-models/ApiUrlEnum'
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient,
    private _apiservice: ApiSendService) {
  }

  verify() {
    //return this.http.get('/api/verify', this.jwt()).map((response: any) => response.json());
    return this.http.get('/api/verify', this.jwt()).pipe(map((response: any) => response.json()));
  }

  forgotPassword(username: string) {
    return this.http.post('/api/forgot-password', JSON.stringify({ username }), this.jwt()).pipe(map((response: any) => response.json()));
  }

  getAll() {
    return this.http.get('/api/users', this.jwt()).pipe(map((response: any) => response.json()));
  }

  getById(id: number) {
    return this.http.get('/api/users/' + id, this.jwt()).pipe(map((response: any) => response.json()));
  }

  create(user: TokenResponseModel) {
    return this.http.post('/api/users', user, this.jwt()).pipe(map((response: any) => response.json()));
  }

  update(user: TokenResponseModel) {
    return this.http.put('/api/users/' + user.Token, user, this.jwt()).pipe(map((response: any) => response.json()));
  }

  delete(id: number) {
    return this.http.delete('/api/users/' + id, this.jwt()).pipe(map((response: any) => response.json()));
  }

  private jwt() {
    // create authorization header with jwt token
    let httpOptionAuthorization = null;
    const currentUser = JSON.parse(localStorage.getItem('DashboardToken'));
    if (currentUser && currentUser.Token) {
      //  const headers = new Headers({ 'vbtauthorization': `${currentUser.Token}` });
      httpOptionAuthorization = {
        Headers: new HttpHeaders({
          'vbtauthorization': `${currentUser.Token}`
        })
      };
      return httpOptionAuthorization;
      //return new RequestOptions({ headers: headers });
    }
  }

  public UserForgetPasswordEmailSend(model: UserForgetPasswordRequestModel) {
    return this._apiservice.Post(ApiUrlEnum.BackOffice, '/api/ForgetUser/UserForgetPasswordEmailSend', model);
  }

  public UserChangePassword(model: UserForgetPasswordRequestModel) {
    return this._apiservice.Post(ApiUrlEnum.BackOffice, '/api/ForgetUser/UserChangePassword', model);
  }

  public GetUserListByName(username) {
    return this._apiservice.GetAuthorization(ApiUrlEnum.BackOffice, '/api/User/GetUserListByName?UserName=' + username);
  }

}
